import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  InputNumber,
  Form,
  RadioGroup,
  Radio,
  IconButton,
  Icon,
  Message,
} from 'rsuite'
import { isValidators, requiredFiled } from '../../../../utils/ValidatorUtils'
import ErrorMessage from '../../../../components/message/errorMessage/ErrorMessage'
import ActivityProductivityTable from './ActivityProductivityTable'
import scrollToComponent from 'react-scroll-to-component'
import NumberFormat from 'react-number-format'

export default function ActivityProductivityForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onSubmit,
  onDelete,
  ...props
}) {
  const { isDeleteError, isError, loading } = props

  const [schema, setSchema] = useState(_schema)
  const [section, setSection] = useState()
  const [productType, setProductType] = useState()
  const [quantity, setQuantity] = useState()
  const [unitOfMeasure, setUnitOfMeasure] = useState()
  const [productDescription, setProductDescription] = useState()

  const [isAdd, setIsAdd] = useState(false)
  const [editId, setEditId] = useState()
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isSaveError, setIsSaveError] = useState(false)

  const selectIdName = 'selectedId'

  // console.log('isAdd => ', isAdd)

  useEffect(() => {
    setSchema(_schema)
    setIsAdd(isError)
    setIsDeleteFail(isDeleteError)
  }, [_schema])

  useEffect(() => {
    setIsSaveError(isError)
    setIsAdd(isError)
  }, [isError])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])

  const onAdd = () => {
    setProductType('')
    setProductDescription('')
    setQuantity('')
    setUnitOfMeasure('')
    setEditId()
    setIsAdd(true)
    setIsSaveError(false)
    setIsDeleteFail(false)

    setValue(schema.productType.name)
    setValue(schema.productDescription.name)
    setValue(schema.quantity.name)
    setValue(schema.unitOfMeasure.name)
    setValue(selectIdName, -1)

    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const onEdit = (rowData) => {
    setProductType(rowData.productType)
    setProductDescription(rowData.productDescription)
    setQuantity(rowData.quantity)
    setUnitOfMeasure(rowData.unitOfMeasure)
    setEditId(rowData.id)
    setIsAdd(true)
    setIsSaveError(false)
    setIsDeleteFail(false)
    setValue(selectIdName, rowData.id)
    setValue(schema.productType.name, rowData.productType)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  return (
    <>
      {/* <Panel
        style={{ marginBottom: 5 }}
        ref={(section) => {
          setSection(section)
        }}
      > */}
      {isAdd && (
        <Form fluid>
          <Controller
            key={selectIdName}
            name={selectIdName}
            control={control}
            defaultValue={editId}
          />
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <ErrorMessage error={errors[schema.productType.name]} />
              <ControlLabel>
                {requiredFiled(schema.productType.validators, schema.productType.label)}
              </ControlLabel>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Controller
                key={schema.productType.name}
                name={schema.productType.name}
                control={control}
                rules={isValidators(schema.productType.validators)}
                defaultValue={productType}
                render={() => {
                  return (
                    <RadioGroup
                      inline
                      value={productType}
                      disabled={schema.productType.disabled}
                      onChange={(value) => {
                        setProductType(value)
                        setValue(schema.productType.name, value)
                      }}
                    >
                      {schema.productType.options.map((item) => {
                        return <Radio value={item.value}>{item.label}</Radio>
                      })}
                    </RadioGroup>
                  )
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 15 }}>
              <ErrorMessage error={errors[schema.productDescription.name]} />
              <ControlLabel>
                {requiredFiled(
                  schema.productDescription.validators,
                  schema.productDescription.label
                )}
              </ControlLabel>
              <Input
                name={schema.productDescription.name}
                rows={3}
                componentClass="textarea"
                value={productDescription}
                placeholder={schema.productDescription.hint}
                disabled={schema.productDescription.disabled}
                inputRef={register(isValidators(schema.productDescription.validators))}
                onChange={(value) => {
                  setProductDescription(value)
                }}
              />
            </Col>
          </Row>
          {productType == 1 && (
            <Row style={{ marginTop: 10 }}>
              <Col xs={24} sm={24} md={10} lg={10}>
                <ErrorMessage error={errors[schema.quantity.name]} />
                <ControlLabel>
                  {requiredFiled(schema.quantity.validators, schema.quantity.label)}
                </ControlLabel>
                <Controller
                  key={schema.quantity.name}
                  name={schema.quantity.name}
                  control={control}
                  rules={isValidators(schema.quantity.validators)}
                  defaultValue={quantity}
                  render={(props) => {
                    return (
                      // <InputNumber
                      //   disabled={schema.quantity.disabled}
                      //   defaultValue={props.value}
                      //   placeholder={schema.quantity.hint}
                      //   onChange={(value) => {
                      //     props.onChange(value)
                      //     setQuantity(value)
                      //   }}
                      // />
                      <NumberFormat
                        className="rs-input"
                        thousandSeparator={true}
                        disabled={schema.quantity.disabled}
                        defaultValue={props.value}
                        placeholder={schema.quantity.hint}
                        onValueChange={(e) => {
                          props.onChange(e.floatValue)
                          setQuantity(e.floatValue)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={14} lg={14}>
                <ErrorMessage error={errors[schema.unitOfMeasure.name]} />
                <ControlLabel>
                  {requiredFiled(schema.unitOfMeasure.validators, schema.unitOfMeasure.label)}
                </ControlLabel>
                <Input
                  name={schema.unitOfMeasure.name}
                  defaultValue={unitOfMeasure}
                  placeholder={schema.unitOfMeasure.hint}
                  disabled={schema.unitOfMeasure.disabled}
                  inputRef={register(isValidators(schema.unitOfMeasure.validators))}
                  onChange={(value) => {
                    setUnitOfMeasure(value)
                  }}
                />
              </Col>
            </Row>
          )}

          {isSaveError && (
            <Row style={{ marginTop: 10 }}>
              <Message
                showIcon
                type="error"
                description={`บันทึก ${schema.buttonText ? schema.buttonText : ''} ไม่สำเร็จ`}
              />
            </Row>
          )}
          <Row style={{ marginTop: 10 }}>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
              <div>
                <IconButton
                  appearance="ghost"
                  className={!editId ? '' : 'rs-btn-ghost-edit'}
                  icon={
                    <Icon
                      appearance="ghost"
                      icon={!editId ? 'save' : 'edit'}
                      className={!editId ? 'bt-gost-icon-radius' : 'bt-gost-icon-radius-edit'}
                    />
                  }
                  onClick={onSubmit}
                  style={{ marginRight: 5 }}
                >
                  {!editId ? 'บันทึก' : 'แก้ไข'}
                  {schema.buttonText && schema.buttonText}
                </IconButton>
                <IconButton
                  appearance="ghost"
                  className="rs-btn-ghost-cancel"
                  icon={<Icon className="bt-gost-icon-radius-cancel" icon="close" />}
                  onClick={(e) => {
                    setIsAdd(false)
                    setIsSaveError(false)
                    setIsDeleteFail(false)
                    scrollToComponent(section, { offset: 1, align: 'top', duration: 500 })
                  }}
                  style={{ marginRight: 5 }}
                >
                  {`ยกเลิก${schema.buttonText && schema.buttonText}`}
                </IconButton>
              </div>
            </Col>
          </Row>
        </Form>
      )}

      {!isAdd && (
        <Row style={{ marginTop: '10px' }}>
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
            <div>
              <IconButton
                appearance="ghost"
                icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
                onClick={onAdd}
                style={{ marginRight: 5 }}
              >
                {`เพิ่ม${schema.buttonText && schema.buttonText}`}
              </IconButton>
            </div>
          </Col>
        </Row>
      )}

      {isDeleteFail && (
        <Row style={{ marginTop: 10 }}>
          <Message
            showIcon
            type="error"
            description={`ลบ ${schema.buttonText ? schema.buttonText : ''} ไม่สำเร็จ`}
          />
        </Row>
      )}
      <Row style={{ marginTop: 10 }}>
        <ActivityProductivityTable
          schema={schema}
          isEdit={true}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      </Row>
      {/* </Panel> */}
    </>
  )
}
